import { render } from "./MessageComposerElement.vue.js?vue&type=template&id=3db2eedc!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageComposerElement.vue?vue&type=template&id=3db2eedc"
import script from "./MessageComposerElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageComposerElement.vue?vue&type=script&lang=js"
export * from "./MessageComposerElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageComposerElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/message-composer/MessageComposerElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3db2eedc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3db2eedc', __exports__)) {
    api.reload('3db2eedc', __exports__)
  }
  
  module.hot.accept("./MessageComposerElement.vue.js?vue&type=template&id=3db2eedc!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageComposerElement.vue?vue&type=template&id=3db2eedc", () => {
    api.rerender('3db2eedc', render)
  })

}


export default __exports__